import Notifications from '@/components/Notifications';
import { theme } from '@/theme';
import { type MantineColorScheme, MantineProvider } from '@mantine/core';
import type { PropsWithChildren } from 'react';
export type ThemeProviderProps = PropsWithChildren & {
  colorScheme: MantineColorScheme;
};
export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  colorScheme
}) => {
  return <MantineProvider theme={theme} defaultColorScheme={colorScheme} classNamesPrefix="app">
      {children}
      <Notifications />
    </MantineProvider>;
};